/**
 * The answer format the system prompt allows — paragraphs, **bold**, *italic*,
 * "- " lists, and bare https links — rendered to HTML. Everything is escaped
 * first and only these constructs are re-introduced, so model output can
 * never inject markup into the host page.
 */
const ESCAPES: Record<string, string> = { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" };

export function escapeHtml(text: string): string {
  return text.replace(/[&<>"']/g, (char) => ESCAPES[char]!);
}

function inline(text: string): string {
  return escapeHtml(text)
    .replace(/\*\*(.+?)\*\*/g, "<strong>$1</strong>")
    // No lookbehind: it is a syntax error on Safari < 16.4 and would take the whole widget down.
    .replace(/(^|[\s(])\*([^\s*](?:[^*]*[^\s*])?)\*(?=[\s).,!?]|$)/g, "$1<em>$2</em>")
    .replace(/\bhttps:\/\/[^\s<]+[^\s<.,;:!?)]/g, (url) => `<a href="${url}" target="_blank" rel="noopener noreferrer">${url.replace(/^https:\/\//, "")}</a>`);
}

export function renderMarkdown(source: string): string {
  const blocks: string[] = [];
  let list: string[] = [];
  let paragraph: string[] = [];
  const flushParagraph = () => {
    if (paragraph.length) blocks.push(`<p>${paragraph.map(inline).join("<br>")}</p>`);
    paragraph = [];
  };
  const flushList = () => {
    if (list.length) blocks.push(`<ul>${list.map((item) => `<li>${inline(item)}</li>`).join("")}</ul>`);
    list = [];
  };

  for (const raw of source.split("\n")) {
    const line = raw.trimEnd();
    const bullet = /^\s*(?:[-*•]|\d+[.)])\s+(.*)$/.exec(line);
    if (bullet) {
      flushParagraph();
      list.push(bullet[1]!);
    } else if (!line.trim()) {
      flushParagraph();
      flushList();
    } else {
      flushList();
      paragraph.push(line.trim());
    }
  }
  flushParagraph();
  flushList();
  return blocks.join("");
}
